const defaultAuthState = {
    isLoggedin: false
}

export default (state = defaultAuthState, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        ...action.auth
      };
    case 'LOGOUT':
      return {
        ...state,
        ...action.newState
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js